import PropTypes from 'prop-types'
import React from 'react'

import { Loader2 } from 'lucide-react';
import { Chart } from 'twyne-new.ui';

import { HeaderActions, HeaderSeparator, TriggerDatePicker } from '@/components/reports/header';

import HeaderContainerGrid from '../headerContainer/Grid';

const propTypes = {
  total: PropTypes.number,
  showing: PropTypes.number,
  title: PropTypes.string,
  collection: PropTypes.string,
  isLoading: PropTypes.bool,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
}

export default class DrilldownHeader extends React.Component {
  Loading = () => {
    if (this.props.isLoading) {
      return <Loader2 className="animate-spin" size="16" />
    }

    return null
  }

  Title = () => <>
    {this.props.title}
    <this.Loading />
  </>

  Dates = () => {
    const { startDate, endDate } = this.props

    if (startDate && endDate) {
      return <TriggerDatePicker values={{ startDate, endDate }} />
    }

    return null
  }

  Statistics = () => {
    const { total, showing } = this.props

    return <>
      <Chart text='Total' value={total} />
      <Chart text='Showing' value={showing} total={total} color='warning' />
    </>
  }

  render() {
    return <HeaderContainerGrid
      title={<>
        <div className='font-bold'>{this.props.collection}</div>
        <div className='mx-1'>•</div>
        <div>{this.props.title}</div>
      </>}
    >
      <HeaderActions>
        <this.Dates />
        <HeaderSeparator />
        <this.Statistics />
      </HeaderActions>
    </HeaderContainerGrid>
  }
}

DrilldownHeader.propTypes = propTypes
DrilldownHeader.defaultProps = {}
